// Once the global loader counter reached zero, it means "loaded" at the moment.
export const isLoaded = state => state.loadingCounter === 0;
